import React from 'react'
import { Text, StyleSheet } from 'react-native'

const DefaultText = (props) => <Text {...props} style={[styles.text, props.style]} />

const styles = StyleSheet.create({
  text: {
    fontSize: 18,
  }
})

export default DefaultText
